import axios from 'axios';
import Mixin from "@utilities/mixin";

export default {
    mixins: [Mixin],
    methods: {
        deleteCustomer(id) {
            const entry_id = parseInt(id);
            axios.delete(`${localized.baseURL}customers/${entry_id}`)
            .then(response => {
                this.getCustomers();
            })
            .catch(error => {
                console.error("Error deleting customer:", error);
            });
        }
    }
}